import { useTranslation } from '@packages/utils';
import { useCheckPermission } from 'hooks/useCheckPermission';
import { useIsFeatureEnabled } from 'hooks/useIsFeatureEnabled';
import FamilyList from 'pages/private/Family/FamilyList';
import EventFamilyList from 'pages/private/Family/EventFamilyList';
import { RoutesPaths, SubRouteType } from 'routes/Routes.types';

const useGetFamilySubRoutesData = () => {
  const { t } = useTranslation({
    keyPrefix: 'descriptions.admin-portal.sidebar',
  });
  const canViewFamily = useCheckPermission('FAMILY_VIEW');
  const isEventsEnabled = useIsFeatureEnabled('events_management');
  const canViewFamilyEvents = canViewFamily && isEventsEnabled;

  const familySubRoutes: SubRouteType[] = [
    {
      title: t('RFK'),
      component: FamilyList,
      path: RoutesPaths.FAMILY,
      show: true,
      showByPermissions: canViewFamily,
    },
    {
      title: t('EVENTS'),
      component: EventFamilyList,
      path: RoutesPaths.FAMILY_EVENTS,
      show: canViewFamilyEvents,
      showByPermissions: canViewFamilyEvents,
    },
  ];
  return { familySubRoutes };
};

export default useGetFamilySubRoutesData;
